// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"554":"6ff40690","958":"aff86576"}[chunkId] + ".chunk.js";
};